module.exports = __webpack_public_path__ + "img/zskydh.6c0e23dd.png";